import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import MarkdownIt from 'markdown-it';
import markdownItAttrs from 'markdown-it-attrs';
import { MetaService } from 'services/meta.service';

class BlogArticle {
	id: number;
	body: string;
	summary: string;
	title: string;
	slug: Date;
	date: Date;
	picture: string;
	description: string;
	keywords: string;
	alt: string;
}

@Component({
	selector: 'ras-article-page',
	templateUrl: './article-page.component.html',
	styleUrls: ['./article-page.component.sass']
})
export class ArticlePageComponent implements OnInit {

	public article: BlogArticle = null
	public articles: BlogArticle[] = null
	public max_recent_articles = 5
	private md = !MarkdownIt ? null : new MarkdownIt()

	constructor(private route: ActivatedRoute, private http: HttpClient, private titleService: Title, private meta: MetaService) {
		if (this.md) {
			this.md.use(markdownItAttrs, {
				allowedAttributes: ['target', 'rel', 'id', 'class']
			})

			var defaultRender = this.md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
				return self.renderToken(tokens, idx, options);
			};

			this.md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
				var aIndex = tokens[idx].attrIndex('target');

				if (aIndex < 0) {
					if (/^https?:/.test(tokens[idx].attrGet('href'))) {
						tokens[idx].attrPush(['target', '_blank']);
					}
				} else {
					// do nothing and use the specified target
				}

				return defaultRender(tokens, idx, options, env, self);
			};
		}
	}

	parse_markdown(markdown_src): string {
		return !this.md ? "" : this.md.render(markdown_src);
	}

	load_articles(exclude_slug): Promise<BlogArticle[]> {
		return new Promise<BlogArticle[]>((resolve, reject) => {
			this.http
			.get("https://rentastore.co.za/articles")
			.toPromise()
			.then((response: any) => {
				let articles: BlogArticle[] = []
				for (let item of response) {
					let article = <BlogArticle> {
						id: item.id,
						body: item.Body,
						summary: item.Summary,
						title: item.Title,
						slug: item.Slug,
						date: item.Date,
						picture: item.Picture.url,
						alt: item.PictureAltText
					}
					if (!exclude_slug || exclude_slug != item.Slug) articles.push(article)
				}
				articles.sort((a, b) => (a.date < b.date) ? 1 : (a.date > b.date) ? -1 : 0 )
				resolve(articles.slice(0, this.max_recent_articles))
			})
		})
	}

	load_article(slug): Promise<BlogArticle> {
		return new Promise<BlogArticle>((resolve, reject) => {
			this.http
			.get("https://rentastore.co.za/articles?Slug=" + escape(slug))
			.toPromise()
			.then((responses: any) => {
				if (responses.length > 0) {
					let response = responses[0]
					let article = <BlogArticle> {
						id: response.id,
						body: response.Body,
						summary: response.Summary,
						title: response.Title,
						description: response.Description,
						keywords: response.Keywords,
						picture: response.Picture.url,
						date: response.Date,
						slug: response.Slug,
						alt: response.PictureAltText
					}
					resolve(article)
				} else reject("Article not found")
			})
		})
	}

	ngOnInit() {
		this.route.paramMap.subscribe(params => {
			let slug = params.get('id')

			this.load_article(slug)
			.then(article => {
				this.article = article
				this.titleService.setTitle(article.title + " - Rent-A-Store")
				this.meta.setMeta('keywords', article.keywords)
				this.meta.setMeta('description', article.description)
			})

			this.load_articles(slug)
			.then(articles => {
				this.articles = articles
			})
		})
	}

}
